export const confirmDelete = item => `Are you sure you want to delete this ${item}?`
